import styled from "styled-components";

export const FooterContainer = styled.div`
    ul{
        list-style: none;
    }
`